import { getToken, getUserId } from '@/utils/token'
import store from '@/store'
import { isUseAPI } from '@/utils/check'
import localStore from '@/utils/localStore'
import { getUserMenu, getSideMenu, getAllSideMenu } from '@/api/system/menuManage' // 메뉴 api 호출
import routers from '@/router'
import { resetRouter } from '@/router'
import _ from 'lodash'

export default {
  state: {
    menus: [],
    // routeMenus: [],
    treeMenus: [],
    gridMenus: [],
    // subTreeMenus: [],
    flag: {
      asideVisiable: true,
      asideUse: true,
      tagViewUse: true,
      headerUse: true,
      footerUse: true,
      myMenuVisible: false,
      fullscreen: false,
      isLayoutHideMode: false,      
    }
  },

  //data를 변경할때
  mutations: {
    // 전체 화면에서 레이아웃을 다 감추는 모드 사용 여부
    SET_LAYOUT_HIDE_MODE(state, flag) {
      state.flag.isLayoutHideMode = flag
    },
    SET_HEADER_USE: function(state, flag) {
      state.flag.headerUse = flag
    },
    SET_TAG_VIEW_USE: function(state, flag) {
      state.flag.tagViewUse = flag
    },
    SET_ASIDE_MENU_USE: (state, flag) => {
      state.flag.asideUse = flag
    },
    SET_FOOTER_USE: function(state, flag) {
      state.flag.footerUse = flag
    },
    SET_FULLSCREEN: function(state, flag) {
      state.flag.fullscreen = flag
    },
    SET_MENU: (state, menus) => {
      state.menus = menus
    },
    // SET_ROUTE_MENU: (state, routeMenus) => {
    //   state.routeMenus = routeMenus
    // },
    SET_TREE_MENU: (state, treeMenus) => {
      state.treeMenus = treeMenus
    },
    // SET_SUB_TREE_MENU: (state, subTreeMenus) => {
    //   state.subTreeMenus = subTreeMenus
    // }
    SET_GRID_MENU: (state, gridMenus) => {
      state.gridMenus = gridMenus
    }

  },
  //methods
  actions: {

    async GetGridMenu({ commit }, userInfo) {
      // console.log('routers', routers)
      // console.log('######userInfo --> ' + JSON.stringify(userInfo))
      return await new Promise((resolve, reject) => {
        // reset
        commit('SET_TREE_MENU', [])

        let menuGridList = []

        //Full menu lookup corresponding to the domain
        getAllSideMenu(userInfo)
          .then(response => {
            // console.log('######menuResult --> ', response.list)
            //Fix: When there is no menu information with initial setting
            if (response.list.length > 0) {
              // console.log('USER_GRD --> ', store.state.user.userGrd)
              // console.log('######menuResult --> ', response.list)
              //console.log('########## authMenu : ' + JSON.stringify(menuList))
              // menuGridList Create dataset
              // Create parent menu data set
              _.cloneDeep(response.list).forEach((item, index) => {
                // console.log('######menuResult --> ' , index + ' -> ' , item)
                // console.log('######menuResult --> ',index + ' -> ',item.menuCode, item.paCode, item.pgCode)
                // if(item.paCode == null || item.paCode == '') {
                // if(item.prtId === null || item.prtId === '') {
                // console.log('######menuList --> ' , item)
                //   menuList.push(item)
                // } else 
                if( item.menuId !== null) {
                  // console.log('######menuTreeList --> ' , item)
                    menuGridList.push({
                          menuId: item.menuId,
                          ename: item.ename,
                          pgmId: item.pgmId,
                          routerId: item.routerId,
                          srt: item.srt,
                          imgButton: item.imgButton,
                          linkAddr: item.linkAddr,
                          saveYN: item.saveYN,
                          children: []
                    })
                }
              })
              // console.log('######menuList --> ' , menuList)
              // console.log('######menuGridList --> ' , menuGridList)
              // console.log('######response.list --> ' , response.list)
              let dynamicRouteInfo = []
              _.cloneDeep(response.list).forEach((item, index) => {
                // console.log('######menuGridList item--> ' , item)
                if ( item.pgmId !== null ) {
                  let newRoute;
                    newRoute = {
                      path: `${item.pgmId}`,
                      name: `${item.pgmId}`,
                      component: () => import(`@/views/tqm${item.routerId}.vue`),
                      meta: { menu_code: `${item.pgmId}`, menu_id: `${item.menuId}`, title: `${item.ename}`, saveYN: `${item.saveYN}`, affix: false }
                      
                  }

                  dynamicRouteInfo.push(newRoute)

                } 
              })
              
              let newRoute = [{
                path: '/',
                redirect: '/pageNotFound',
                component: () => import('@/layout/layout.vue'),
                children: dynamicRouteInfo
              }]
              
              resetRouter()
              routers.addRoutes(newRoute)

              // console.log("#######menuGridList : ", menuGridList)
              // console.log("#######newRoute : ", newRoute)
              // console.log('en2',routers.meta.menu_id)

              commit('SET_TREE_MENU', menuGridList)
              commit('SET_MENU', menuGridList)

              
            }
          })
          .catch(error => {
            reject(error)
          }),
          resolve()
      })
    },

   
    async GetSubMenus({ commit }, flag) {
      return await new Promise((resolve, reject) => {
        // commit('SET_SUB_TREE_MENU', flag)
        // resolve()
      })
      
    },
    SetHeaderUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_HEADER_USE', flag)
    },
    SetTagViewUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_TAG_VIEW_USE', flag)
    },
    SetASideMenuUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_ASIDE_MENU_USE', flag)
    },
    SetFooterUse({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_FOOTER_USE', flag)
    },
    SetLayoutHideMode({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_LAYOUT_HIDE_MODE', flag)
    },
    SetFullScreen({ commit }, flag) {
      if (typeof flag !== 'boolean') return
      commit('SET_FULLSCREEN', flag)
      localStore.set('fullscreen', this.isFullscreen) // Keep it in case you need it later
      if (store.state.menu.flag.isLayoutHideMode === true) {
        commit('SET_HEADER_USE', !flag)
        commit('SET_TAG_VIEW_USE', !flag)
        commit('SET_ASIDE_MENU_USE', !flag)
        commit('SET_FOOTER_USE', !flag)
      }
    }
  },

  getters: {
    //computed
  }
}
